import apiClient from './apiClient';

const guestService = {
  // DRF endpoints (snake_case response, full CRUD, trailing slash)
  getAll: (params) => apiClient.get('/guests/', params),
  getById: (id) => apiClient.get(`/guests/${id}/`),
  create: (data) => apiClient.post('/guests/', data),
  update: (id, data) => apiClient.patch(`/guests/${id}/`, data),
  remove: (id) => apiClient.del(`/guests/${id}/`),

  // Nested resources
  addAddress: (guestId, data) => apiClient.post(`/guests/${guestId}/addresses/`, data),
  updateAddress: (guestId, addressId, data) => apiClient.patch(`/guests/${guestId}/addresses/${addressId}/`, data),
  removeAddress: (guestId, addressId) => apiClient.del(`/guests/${guestId}/addresses/${addressId}/`),
  addIdentification: (guestId, data) => apiClient.post(`/guests/${guestId}/identifications/`, data),
};

export default guestService;
